/**
 * @file Service.js
 * @desc 业务逻辑store
 * @author YongZhang<zhangyong06@baidu.com>
 */
'use strict';
import wywLog from '@/utils/ubcLog';
import {getContractList, getContractInfo} from '@/pages/ai-contract/util';
import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
export default {
    namespaced: true,
    state: {
        aiContract: {
            // 最新生成的合同id
            latestId: '',
            // 正在生成的合同id
            generatingId: '',
            // 当前会话的合同信息（从生成中变更为任意状态）
            // 合同状态status：0 生成中 1 生成成功 2 生成失败
            contractInfo: {},
            // 轮询计时器
            watchTimer: 0
        }
    },
    actions: {
        /**
         * 检查是否有进行中的智能合同生成，如果有则轮询生成状态直至结束
         * @param {number} params.id 进行中合同id，可选
         * @returns
         */
        async getCurrentContract({commit, state, dispatch}, params = {}) {
            // 已经有生成中合同的id，直接开始轮询状态
            if (state.aiContract.generatingId) {
                dispatch('watchCurrentContract');
                return;
            }
            let generatingId = params.id;
            // 未知是否有进行中的智能合同生成，则查询进行中的列表
            if (!generatingId) {
                const generatingList = await getContractList('0').catch(() => {}) || [];
                generatingId = generatingList[0]?.id || '';
            }
            if (generatingId) {
                // 保存进行中的id, 开始轮询状态
                commit('setAIContract', {
                    generatingId,
                    contractInfo: {status: 0}
                });
                dispatch('watchCurrentContract');
            }
        },
        /**
         * 获取最新生成的合同id
         */
        async getLatestContract({commit, state, dispatch}) {
            const generatedList = await getContractList('1').catch(() => {}) || [];
            commit('setAIContract', {
                latestId: generatedList[0]?.id || ''
            });
        },
        // 检查是否有进行中的智能合同生成，如果有则轮询生成状态直至结束
        async watchCurrentContract({commit, state, dispatch}) {
            const {latestId, generatingId, contractInfo, watchTimer} = state.aiContract;
            if (generatingId && +contractInfo?.status === 0) {
                const info =  await getContractInfo(generatingId);
                commit('setAIContract', {
                    // 进行中到完成，则更新最新的合同id
                    latestId: +info.status === 1 ? generatingId : latestId,
                    // 进行中，更新进行中id
                    generatingId: +info.status === 0 ? generatingId : '',
                    contractInfo: info
                });
                clearTimeout(watchTimer);
                if (+info.status === 0) {
                    state.aiContract.watchTimer = setTimeout(() => {
                        dispatch('watchCurrentContract');
                    }, 5000);
                }
                else {
                    wywLog.send({
                        page: 'AIContract',
                        serverId: 17047,
                        action: 'show',
                        area: 'answer-api',
                        success: +info.status === 1 ? 1 : 0
                    });
                }
            }
        }
    },
    mutations: {

        /**
         * 设置智能合同生成信息
         *
         * @param {Object} state 状态树
         * @param {Object} info  智能合同生成信息
         */
        setAIContract(state, info) {
            state.aiContract = {...state.aiContract, ...info};
        }
    }
};